import { useCallback } from 'react';
import { Button } from '../../../../input/Button';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { FeedManagementFilterProps } from './types';

export const FeedManagementFilter: React.FC<FeedManagementFilterProps> = ({
    title,
    value: selectedValue,
    options,
    additionalOption,
    onChange,
}) => {
    const onClick = useCallback(
        (value: string) => {
            if (value === selectedValue) {
                onChange(null);

                return;
            }

            onChange(value);
        },
        [onChange, selectedValue],
    );

    return (
        <Flex width="100%">
            <Typography variant="body" weight="bold">
                {title}
            </Typography>
            <Flex direction="row" spacing={1} mt={1.5} flexWrap="wrap" width="100%">
                {options.map((option) => (
                    <Button
                        key={option.value}
                        size="m"
                        color={selectedValue === option.value ? 'primary' : 'secondary'}
                        onClick={() => onClick(option.value)}
                        whiteSpace="nowrap"
                    >
                        {option.displayName}
                    </Button>
                ))}
                {additionalOption}
            </Flex>
        </Flex>
    );
};
